import { createApi } from '@reduxjs/toolkit/query/react';

import { jotWorkerBaseQuery } from './jotWorkerBaseQuery';

/** Shared service slice; feature modules inject the generated JotWorker endpoints. */
export const jotWorkerApi = createApi({
  reducerPath: 'jotWorkerApi',
  baseQuery: jotWorkerBaseQuery,
  endpoints: () => ({}),
});
